package br.com.htms.inspeccaocampo.ui.screens

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.material3.Button
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.DropdownMenu
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.ExposedDropdownMenuBox
import androidx.compose.material3.ExposedDropdownMenuDefaults
import androidx.compose.material3.FloatingActionButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.RadioButton
import androidx.compose.material3.Scaffold
import androidx.compose.material3.SnackbarHost
import androidx.compose.material3.SnackbarHostState
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.semantics.Role
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextDecoration
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import br.com.htms.inspeccaocampo.data.CaracterizacaoOcorrencia
import br.com.htms.inspeccaocampo.data.ClasseEventoOcorrencia
import br.com.htms.inspeccaocampo.data.RespostaSimNao
import br.com.htms.inspeccaocampo.data.TipoOcorrencia
import br.com.htms.inspeccaocampo.form.AppController
import br.com.htms.inspeccaocampo.shared.ui.components.ButtonLoadingContent
import br.com.htms.inspeccaocampo.shared.ui.components.CampoFotoRow
import br.com.htms.inspeccaocampo.shared.ui.components.CenteredAppDialog
import br.com.htms.inspeccaocampo.shared.ui.components.FormFieldDefaults
import kotlinx.coroutines.launch

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun SharedComunicacaoOcorrenciasScreen(controller: AppController) {
    val form by controller.ocorrenciasForm.collectAsState()
    val erros by controller.erros.collectAsState()
    val mensagem by controller.mensagem.collectAsState()
    val obrasAtivas by controller.obrasAtivas.collectAsState()
    val capturandoGps by controller.capturandoGps.collectAsState()
    val appConfig by controller.appConfig.collectAsState()

    val snackbar = remember { SnackbarHostState() }
    val scope = rememberCoroutineScope()
    val listState = rememberLazyListState()
    var menuObraAberto by remember { mutableStateOf(false) }
    var mostrarListaFotos by remember { mutableStateOf(false) }

    fun rotulo(id: String, padrao: String) = appConfig.rotuloOcorrencia(id, padrao)
    fun ativo(id: String) = appConfig.ocorrenciaAtiva(id)

    fun scrollSeguro(index: Int) {
        scope.launch {
            val total = listState.layoutInfo.totalItemsCount
            if (total <= 0) return@launch
            listState.animateScrollToItem(index.coerceIn(0, total - 1))
        }
    }

    LaunchedEffect(Unit) {
        controller.carregarObrasAtivas()
    }

    LaunchedEffect(mensagem) {
        val msg = mensagem ?: return@LaunchedEffect
        snackbar.showSnackbar(msg)
        controller.consumirMensagem()
    }

    LaunchedEffect(erros) {
        if (erros.isEmpty()) return@LaunchedEffect
        runCatching { listState.animateScrollToItem(0) }
    }

    val coordsTexto = when {
        form.latitude != null && form.longitude != null ->
            "Lat: ${form.latitude}  Lng: ${form.longitude}"
        else -> ""
    }

    Scaffold(
        snackbarHost = { SnackbarHost(snackbar) }
    ) { padding ->
        Box(
            modifier = Modifier
                .fillMaxSize()
                .padding(padding)
                .background(Color.Transparent)
        ) {
            LazyColumn(
                state = listState,
                modifier = Modifier.fillMaxSize(),
                contentPadding = PaddingValues(bottom = 96.dp),
                verticalArrangement = Arrangement.spacedBy(12.dp)
            ) {
                item {
                    OutlinedButton(
                        onClick = { controller.voltarAoHub() },
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(horizontal = 16.dp, vertical = 8.dp)
                    ) { Text("Voltar") }
                }

                item {
                    Column(Modifier.padding(horizontal = 16.dp)) {
                        Text(
                            "Comunicação de ocorrências",
                            fontWeight = FontWeight.Bold,
                            style = MaterialTheme.typography.titleMedium
                        )
                        Text(
                            "Acidente, incidentes e quase acidentes",
                            style = MaterialTheme.typography.bodyMedium,
                            color = MaterialTheme.colorScheme.onSurfaceVariant
                        )
                    }
                }

                if (ativo("cliente") || ativo("obra")) {
                item {
                    Card(
                        modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp),
                        colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surface)
                    ) {
                        Column(Modifier.padding(12.dp), verticalArrangement = Arrangement.spacedBy(10.dp)) {
                            Text("Dados da obra", fontWeight = FontWeight.Bold)
                            if (ativo("cliente")) {
                            OutlinedTextField(
                                value = form.cliente,
                                onValueChange = { v ->
                                    controller.atualizarOcorrencias { it.copy(cliente = v) }
                                },
                                label = { Text("${rotulo("cliente", "Cliente")} *") },
                                modifier = Modifier.fillMaxWidth(),
                                colors = FormFieldDefaults.textFieldColors(),
                                isError = controller.erroNoCampo("cliente") != null
                            )
                            }
                            if (ativo("obra")) {
                            ExposedDropdownMenuBox(
                                expanded = menuObraAberto,
                                onExpandedChange = { menuObraAberto = it }
                            ) {
                                OutlinedTextField(
                                    value = form.obra.ifBlank { "Selecione a obra" },
                                    onValueChange = {},
                                    readOnly = true,
                                    label = { Text("${rotulo("obra", "Nome da obra")} *") },
                                    trailingIcon = {
                                        ExposedDropdownMenuDefaults.TrailingIcon(expanded = menuObraAberto)
                                    },
                                    modifier = Modifier
                                        .fillMaxWidth()
                                        .menuAnchor(),
                                    colors = FormFieldDefaults.textFieldColors(),
                                    isError = controller.erroNoCampo("obra") != null,
                                    singleLine = true
                                )
                                DropdownMenu(
                                    expanded = menuObraAberto,
                                    onDismissRequest = { menuObraAberto = false }
                                ) {
                                    obrasAtivas.forEach { obraItem ->
                                        DropdownMenuItem(
                                            text = {
                                                Text(
                                                    obraItem.nome,
                                                    maxLines = 2,
                                                    overflow = TextOverflow.Ellipsis
                                                )
                                            },
                                            onClick = {
                                                controller.atualizarOcorrencias { it.copy(obra = obraItem.nome) }
                                                menuObraAberto = false
                                            }
                                        )
                                    }
                                }
                            }
                            }
                        }
                    }
                }
                }

                item {
                    Card(
                        modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp),
                        colors = CardDefaults.cardColors(containerColor = Color(0xFFB3C9E8))
                    ) {
                        Column(Modifier.padding(12.dp), verticalArrangement = Arrangement.spacedBy(10.dp)) {
                            Text("Local (GPS)", fontWeight = FontWeight.Bold)
                            OutlinedTextField(
                                value = form.localTexto.ifBlank { "Aguardando GPS..." },
                                onValueChange = {},
                                readOnly = true,
                                label = { Text("Local (GPS)") },
                                modifier = Modifier.fillMaxWidth(),
                                colors = FormFieldDefaults.textFieldColors(),
                                isError = controller.erroNoCampo("localGps") != null
                            )
                            if (coordsTexto.isNotBlank()) {
                                Text(
                                    coordsTexto,
                                    style = MaterialTheme.typography.bodySmall,
                                    color = MaterialTheme.colorScheme.onSurfaceVariant
                                )
                            }
                            OutlinedButton(
                                onClick = { controller.capturarGpsOcorrencias() },
                                enabled = !capturandoGps,
                                modifier = Modifier.fillMaxWidth()
                            ) {
                                ButtonLoadingContent(
                                    loading = capturandoGps,
                                    loadingText = "Capturando GPS...",
                                    idleText = "Atualizar local por GPS"
                                )
                            }
                        }
                    }
                }

                if (ativo("caracterizacao")) {
                item {
                    RadioGroupCard(
                        titulo = "${rotulo("caracterizacao", "Caracterização")} *",
                        erro = controller.erroNoCampo("caracterizacao")
                    ) {
                        CaracterizacaoOcorrencia.entries.forEach { opcao ->
                            RadioLinha(
                                selecionado = form.caracterizacao == opcao,
                                rotulo = opcao.rotulo,
                                onClick = {
                                    controller.atualizarOcorrencias { it.copy(caracterizacao = opcao) }
                                }
                            )
                        }
                    }
                }
                }

                if (ativo("tipo")) {
                item {
                    RadioGroupCard(
                        titulo = "${rotulo("tipo", "Tipo")} *",
                        erro = controller.erroNoCampo("tipo")
                    ) {
                        TipoOcorrencia.entries.forEach { opcao ->
                            RadioLinha(
                                selecionado = form.tipo == opcao,
                                rotulo = opcao.rotulo,
                                onClick = {
                                    controller.atualizarOcorrencias { it.copy(tipo = opcao) }
                                }
                            )
                        }
                    }
                }
                }

                if (ativo("dataHoraOcorrido") || ativo("localExato") || ativo("quemReportando")) {
                item {
                    Card(
                        modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp),
                        colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surface)
                    ) {
                        Column(Modifier.padding(12.dp), verticalArrangement = Arrangement.spacedBy(10.dp)) {
                            Text("Identificação do evento", fontWeight = FontWeight.Bold)
                            if (ativo("dataHoraOcorrido")) {
                            OutlinedTextField(
                                value = form.dataHoraOcorrido,
                                onValueChange = { v ->
                                    controller.atualizarOcorrencias { it.copy(dataHoraOcorrido = v) }
                                },
                                label = { Text("${rotulo("dataHoraOcorrido", "Data e hora do ocorrido")} *") },
                                placeholder = { Text("dd/mm/aaaa hh:mm") },
                                modifier = Modifier.fillMaxWidth(),
                                colors = FormFieldDefaults.textFieldColors(),
                                isError = controller.erroNoCampo("dataHoraOcorrido") != null
                            )
                            }
                            if (ativo("localExato")) {
                            OutlinedTextField(
                                value = form.localExato,
                                onValueChange = { v ->
                                    controller.atualizarOcorrencias { it.copy(localExato = v) }
                                },
                                label = { Text("${rotulo("localExato", "Local exato (setor/frente de serviço)")} *") },
                                modifier = Modifier.fillMaxWidth(),
                                minLines = 2,
                                colors = FormFieldDefaults.textFieldColors(),
                                isError = controller.erroNoCampo("localExato") != null
                            )
                            }
                            if (ativo("quemReportando")) {
                            OutlinedTextField(
                                value = form.quemReportando,
                                onValueChange = { v ->
                                    controller.atualizarOcorrencias { it.copy(quemReportando = v) }
                                },
                                label = { Text("${rotulo("quemReportando", "Quem está reportando")} *") },
                                modifier = Modifier.fillMaxWidth(),
                                colors = FormFieldDefaults.textFieldColors(),
                                isError = controller.erroNoCampo("quemReportando") != null
                            )
                            }
                        }
                    }
                }
                }

                if (ativo("tipoEvento")) {
                item {
                    RadioGroupCard(
                        titulo = "${rotulo("tipoEvento", "Tipo de evento")} *",
                        erro = controller.erroNoCampo("tipoEvento")
                    ) {
                        ClasseEventoOcorrencia.entries.forEach { opcao ->
                            RadioLinha(
                                selecionado = form.tipoEvento == opcao,
                                rotulo = opcao.rotulo,
                                onClick = {
                                    controller.atualizarOcorrencias { it.copy(tipoEvento = opcao) }
                                }
                            )
                        }
                    }
                }
                }

                if (ativo("envolvido")) {
                item {
                    Card(
                        modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp),
                        colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surface)
                    ) {
                        Column(Modifier.padding(12.dp), verticalArrangement = Arrangement.spacedBy(10.dp)) {
                            Text(rotulo("envolvido", "Dados do Envolvido"), fontWeight = FontWeight.Bold)
                            OutlinedTextField(
                                value = form.envolvidoNome,
                                onValueChange = { v ->
                                    controller.atualizarOcorrencias { it.copy(envolvidoNome = v) }
                                },
                                label = { Text("Nome *") },
                                modifier = Modifier.fillMaxWidth(),
                                colors = FormFieldDefaults.textFieldColors(),
                                isError = controller.erroNoCampo("envolvidoNome") != null
                            )
                            OutlinedTextField(
                                value = form.envolvidoFuncao,
                                onValueChange = { v ->
                                    controller.atualizarOcorrencias { it.copy(envolvidoFuncao = v) }
                                },
                                label = { Text("Função *") },
                                modifier = Modifier.fillMaxWidth(),
                                colors = FormFieldDefaults.textFieldColors(),
                                isError = controller.erroNoCampo("envolvidoFuncao") != null
                            )
                        }
                    }
                }
                }

                if (ativo("responsavel")) {
                item {
                    Card(
                        modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp),
                        colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surface)
                    ) {
                        Column(Modifier.padding(12.dp), verticalArrangement = Arrangement.spacedBy(10.dp)) {
                            Text(rotulo("responsavel", "Responsável pela atividade"), fontWeight = FontWeight.Bold)
                            OutlinedTextField(
                                value = form.responsavelAtividade,
                                onValueChange = { v ->
                                    controller.atualizarOcorrencias { it.copy(responsavelAtividade = v) }
                                },
                                label = { Text("Responsável pela atividade *") },
                                modifier = Modifier.fillMaxWidth(),
                                colors = FormFieldDefaults.textFieldColors(),
                                isError = controller.erroNoCampo("responsavelAtividade") != null
                            )
                            OutlinedTextField(
                                value = form.responsavelCargo,
                                onValueChange = { v ->
                                    controller.atualizarOcorrencias { it.copy(responsavelCargo = v) }
                                },
                                label = { Text("Cargo *") },
                                modifier = Modifier.fillMaxWidth(),
                                colors = FormFieldDefaults.textFieldColors(),
                                isError = controller.erroNoCampo("responsavelCargo") != null
                            )
                            Text("Estava no local *", fontWeight = FontWeight.SemiBold)
                            RespostaSimNao.entries.forEach { opcao ->
                                RadioLinha(
                                    selecionado = form.responsavelEstavaNoLocal == opcao,
                                    rotulo = opcao.rotulo,
                                    onClick = {
                                        controller.atualizarOcorrencias {
                                            it.copy(responsavelEstavaNoLocal = opcao)
                                        }
                                    }
                                )
                            }
                            controller.erroNoCampo("responsavelEstavaNoLocal")?.let {
                                Text(it, color = MaterialTheme.colorScheme.error, style = MaterialTheme.typography.bodySmall)
                            }
                        }
                    }
                }
                }

                if (ativo("dadosAcidente")) {
                item {
                    Card(
                        modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp),
                        colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surface)
                    ) {
                        Column(Modifier.padding(12.dp), verticalArrangement = Arrangement.spacedBy(10.dp)) {
                            Text(rotulo("dadosAcidente", "Dados da Ocorrência"), fontWeight = FontWeight.Bold)
                            OutlinedTextField(
                                value = form.dataAcidente,
                                onValueChange = { v ->
                                    controller.atualizarOcorrencias { it.copy(dataAcidente = v) }
                                },
                                label = { Text("Data do acidente *") },
                                placeholder = { Text("dd/mm/aaaa") },
                                modifier = Modifier.fillMaxWidth(),
                                colors = FormFieldDefaults.textFieldColors(),
                                isError = controller.erroNoCampo("dataAcidente") != null
                            )
                            OutlinedTextField(
                                value = form.horaAcidente,
                                onValueChange = { v ->
                                    controller.atualizarOcorrencias { it.copy(horaAcidente = v) }
                                },
                                label = { Text("Hora do acidente *") },
                                placeholder = { Text("hh:mm") },
                                modifier = Modifier.fillMaxWidth(),
                                colors = FormFieldDefaults.textFieldColors(),
                                isError = controller.erroNoCampo("horaAcidente") != null
                            )
                            OutlinedTextField(
                                value = form.horasTrabalhadas,
                                onValueChange = { v ->
                                    controller.atualizarOcorrencias { it.copy(horasTrabalhadas = v) }
                                },
                                label = { Text("Horas trabalhadas *") },
                                modifier = Modifier.fillMaxWidth(),
                                colors = FormFieldDefaults.textFieldColors(),
                                isError = controller.erroNoCampo("horasTrabalhadas") != null
                            )
                            OutlinedTextField(
                                value = form.localAcidente,
                                onValueChange = { v ->
                                    controller.atualizarOcorrencias { it.copy(localAcidente = v) }
                                },
                                label = { Text("Local do acidente *") },
                                modifier = Modifier.fillMaxWidth(),
                                colors = FormFieldDefaults.textFieldColors(),
                                isError = controller.erroNoCampo("localAcidente") != null
                            )
                            OutlinedTextField(
                                value = form.parteCorpoLesionada,
                                onValueChange = { v ->
                                    controller.atualizarOcorrencias { it.copy(parteCorpoLesionada = v) }
                                },
                                label = { Text("Parte do corpo lesionada *") },
                                modifier = Modifier.fillMaxWidth(),
                                colors = FormFieldDefaults.textFieldColors(),
                                isError = controller.erroNoCampo("parteCorpoLesionada") != null
                            )
                            OutlinedTextField(
                                value = form.agenteCausador,
                                onValueChange = { v ->
                                    controller.atualizarOcorrencias { it.copy(agenteCausador = v) }
                                },
                                label = { Text("Agente causador da lesão *") },
                                modifier = Modifier.fillMaxWidth(),
                                colors = FormFieldDefaults.textFieldColors(),
                                isError = controller.erroNoCampo("agenteCausador") != null
                            )
                            OutlinedTextField(
                                value = form.naturezaLesao,
                                onValueChange = { v ->
                                    controller.atualizarOcorrencias { it.copy(naturezaLesao = v) }
                                },
                                label = { Text("Natureza da lesão *") },
                                modifier = Modifier.fillMaxWidth(),
                                colors = FormFieldDefaults.textFieldColors(),
                                isError = controller.erroNoCampo("naturezaLesao") != null
                            )
                        }
                    }
                }
                }

                if (ativo("acoesTomadasImediato") || ativo("descricaoEvento")) {
                item {
                    Card(
                        modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp),
                        colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surface)
                    ) {
                        Column(Modifier.padding(12.dp), verticalArrangement = Arrangement.spacedBy(10.dp)) {
                            if (ativo("acoesTomadasImediato")) {
                            Text("${rotulo("acoesTomadasImediato", "Ações tomadas de imediato")} *", fontWeight = FontWeight.Bold)
                            OutlinedTextField(
                                value = form.acoesTomadasImediato,
                                onValueChange = { v ->
                                    controller.atualizarOcorrencias { it.copy(acoesTomadasImediato = v) }
                                },
                                label = { Text(rotulo("acoesTomadasImediato", "Ações tomadas de imediato")) },
                                modifier = Modifier.fillMaxWidth(),
                                minLines = 3,
                                colors = FormFieldDefaults.textFieldColors(),
                                isError = controller.erroNoCampo("acoesTomadasImediato") != null
                            )
                            }
                            if (ativo("descricaoEvento")) {
                            Text("${rotulo("descricaoEvento", "Descrição do Evento")} *", fontWeight = FontWeight.Bold)
                            OutlinedTextField(
                                value = form.descricaoEvento,
                                onValueChange = { v ->
                                    controller.atualizarOcorrencias { it.copy(descricaoEvento = v) }
                                },
                                label = { Text(rotulo("descricaoEvento", "Descrição do Evento")) },
                                modifier = Modifier.fillMaxWidth(),
                                minLines = 4,
                                colors = FormFieldDefaults.textFieldColors(),
                                isError = controller.erroNoCampo("descricaoEvento") != null
                            )
                            }
                        }
                    }
                }
                }

                if (ativo("fotos")) {
                item {
                    Card(
                        modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp),
                        colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surface)
                    ) {
                        Column(Modifier.padding(12.dp), verticalArrangement = Arrangement.spacedBy(10.dp)) {
                            Text("${rotulo("fotos", "Fotos")} *", fontWeight = FontWeight.Bold)
                            CampoFotoRow(
                                label = "Adicionar foto",
                                obrigatorio = true,
                                quantidadeFotos = form.fotos.size,
                                onTirarFoto = { controller.adicionarFotoOcorrencias() },
                                onAdicionarMais = { controller.adicionarFotoOcorrencias() },
                                onAbrirLista = { mostrarListaFotos = true }
                            )
                            controller.erroNoCampo("fotos")?.let {
                                Text(it, color = MaterialTheme.colorScheme.error, style = MaterialTheme.typography.bodySmall)
                            }
                        }
                    }
                }
                }

                if (erros.isNotEmpty()) {
                    item {
                        Card(
                            modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp),
                            colors = CardDefaults.cardColors(
                                containerColor = MaterialTheme.colorScheme.errorContainer
                            )
                        ) {
                            Column(
                                modifier = Modifier.padding(12.dp),
                                verticalArrangement = Arrangement.spacedBy(6.dp)
                            ) {
                                Text("Corrija os campos obrigatórios:", fontWeight = FontWeight.Bold)
                                erros.take(5).forEach { erro ->
                                    Text(
                                        text = "• ${erro.mensagem}",
                                        color = MaterialTheme.colorScheme.onErrorContainer,
                                        textDecoration = TextDecoration.Underline,
                                        modifier = Modifier
                                            .fillMaxWidth()
                                            .clickable { scope.launch { listState.animateScrollToItem(0) } }
                                            .padding(vertical = 4.dp)
                                    )
                                }
                                if (erros.size > 5) {
                                    Text("... e mais ${erros.size - 5}")
                                }
                            }
                        }
                    }
                }

                item {
                    Button(
                        onClick = { controller.validarESalvarOcorrencias() },
                        modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp)
                    ) { Text("Salvar") }
                }
            }

            Column(
                modifier = Modifier
                    .align(Alignment.BottomEnd)
                    .padding(16.dp),
                verticalArrangement = Arrangement.spacedBy(8.dp)
            ) {
                FloatingActionButton(
                    onClick = { scrollSeguro(0) },
                    containerColor = MaterialTheme.colorScheme.primaryContainer
                ) {
                    Text("Início", fontWeight = FontWeight.Bold, style = MaterialTheme.typography.labelSmall)
                }
                FloatingActionButton(
                    onClick = {
                        val last = (listState.layoutInfo.totalItemsCount - 1).coerceAtLeast(0)
                        scrollSeguro(last)
                    },
                    containerColor = MaterialTheme.colorScheme.primaryContainer
                ) {
                    Text("Fim", fontWeight = FontWeight.Bold, style = MaterialTheme.typography.labelSmall)
                }
            }
        }
    }

    if (mostrarListaFotos) {
        val ultimaFoto = form.fotos.lastOrNull()
        CenteredAppDialog(
            onDismissRequest = { mostrarListaFotos = false },
            title = "Fotos da ocorrência",
            text = if (form.fotos.isEmpty()) {
                "Nenhuma foto."
            } else {
                "${form.fotos.size} foto(s). Remover a última?"
            },
            confirmLabel = if (ultimaFoto != null) "Remover última" else null,
            onConfirm = if (ultimaFoto != null) {
                {
                    controller.removerFotoOcorrencias(ultimaFoto)
                    if (form.fotos.size <= 1) mostrarListaFotos = false
                }
            } else {
                null
            },
            dismissLabel = "Fechar"
        )
    }
}

@Composable
private fun RadioGroupCard(
    titulo: String,
    erro: String?,
    content: @Composable () -> Unit
) {
    Card(
        modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp),
        colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surface)
    ) {
        Column(Modifier.padding(12.dp), verticalArrangement = Arrangement.spacedBy(6.dp)) {
            Text(titulo, fontWeight = FontWeight.Bold)
            content()
            if (erro != null) {
                Text(erro, color = MaterialTheme.colorScheme.error, style = MaterialTheme.typography.bodySmall)
            }
        }
    }
}

@Composable
private fun RadioLinha(
    selecionado: Boolean,
    rotulo: String,
    onClick: () -> Unit
) {
    Row(
        verticalAlignment = Alignment.CenterVertically,
        modifier = Modifier
            .fillMaxWidth()
            .clickable(role = Role.RadioButton, onClick = onClick)
            .padding(vertical = 4.dp)
    ) {
        RadioButton(selected = selecionado, onClick = null)
        Text(rotulo)
    }
}
